module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_iter-step.js
// module id = 421
// module chunks = 1